import { Component, OnInit, forwardRef, NgZone } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Time } from 'src/core/models/time';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { TranslateService } from '@ngx-translate/core';

const noop = () => {
};

@Component({
  selector: 'adahi-time-control',
  templateUrl: './time-control.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TimeControlComponent), multi: true }
  ]
})
export class TimeControlComponent extends BaseTranslation implements ControlValueAccessor, OnInit {

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  time: Time = { hour: 0, minute: 0 };

  hourConfig: { [k: string]: any } = {
    search: false,
    limitTo: 100000,
    customComparator: (n: number) => n
  };

  minConfig: { [k: string]: any } = {
    search: false,
    limitTo: 100000,
    customComparator: (n: number) => n
  };

  hourOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
  minsOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59];

  constructor(translateService: TranslateService, ngZone: NgZone) {
    super(translateService, ngZone);
  }

  //#region Lifecycle Hooks
  ngOnInit() {
    this.minsOptions = [...this.minsOptions];
    this.hourOptions = [...this.hourOptions];
    this.initDropDownLocalization();
  }
  //#endregion

  //#region ControlValueAccessor Methods


  writeValue(obj: any): void {
    let time = obj as Time;
    if (time) {
      this.fixTime(time);
      this.time = { ...time }
    } else {
      this.time.hour = 0;
      this.time.minute = 0;
    }

    this.minsOptions = [...this.minsOptions];
    this.hourOptions = [...this.hourOptions];
    this.time = { ...this.time }

    // this.onChangeCallback(this.time);
  }

  set value(v: any) {
    let time = v as Time;
    if (time) {
      this.fixTime(time);
      this.time = { ...time };
      this.onChangeCallback(time);
      this.onTouchedCallback();
    } else {
      this.onChangeCallback(null);
      this.onTouchedCallback();
    }

    this.minsOptions = [...this.minsOptions];
    this.hourOptions = [...this.hourOptions];

  }

  get value(): any {
    this.fixTime(this.time);
    return this.time;
  };

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;

  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  //#endregion


  initDropDownLocalization() {

    this.translate.get('TimeControl.Hour').subscribe(Hour => {
      this.hourConfig.placeholder = Hour;
    });

    this.translate.get('TimeControl.Minute').subscribe(Minute => {
      this.minConfig.placeholder = Minute;
    });
  }


  onClickedOutside(e: Event) {
    setTimeout(() => { }, 100);
  }

  onMinsChange(min) {
    this.fixTime(this.time);
    this.value = { ...this.time };
    // this.minsOptions = [...this.minsOptions];
    // this.hourOptions = [...this.hourOptions];

    // if (this.time && this.time.minute != null && this.time.minute != undefined && this.time.hour != null && this.time.hour != undefined) {
    //     this.value = this.time;
    // } else {
    //     this.value = null;
    // }
  }

  onHourChange(hour) {
    this.fixTime(this.time);
    this.value = { ...this.time };
    // this.minsOptions = [...this.minsOptions];
    // this.hourOptions = [...this.hourOptions];

    // if (this.time && this.time.minute != null && this.time.minute != undefined && this.time.hour != null && this.time.hour != undefined) {         
    //     this.value = this.time;
    // } else {
    //     this.value = null;
    // }
  }

  fixTime = (time: Time) => {
    time.minute = typeof time.minute == 'number' ? time.minute : 0;
    time.hour = typeof time.hour == 'number' ? time.hour : 0;
  }

}
